import { SearchIcon } from "lucide-react";
import React, { forwardRef, useImperativeHandle } from "react";

import DataTableSearchInput from "./SearchInput";

import { Button } from "@/components/ui/button";

type SearchProps = {
  search?: string;
  updateParams: (key: string, value: string) => void;
};

const Search = forwardRef(
  ({ search, updateParams }: SearchProps, ref): JSX.Element => {
    const [showSearch, setShowSearch] = React.useState(false);

    const handleSearch = (e: string): void => {
      updateParams("search", e);
    };

    useImperativeHandle(ref, () => ({
      // upon clicking the clear filter this should reset the fortnight picker date too
      resetSearch: (): void => {
        setShowSearch(false);
        updateParams("search", "");
      },
    }));

    return search && !showSearch ? (
      <Button
        className=' h-9'
        variant='ghost'
        onClick={() => setShowSearch(true)}
      >
        <SearchIcon className='w-4 h-4 mr-2' />
        Search
      </Button>
    ) : (
      <DataTableSearchInput
        autoFocus
        onChange={(e) => handleSearch(e ?? "")}
        onExit={() => {
          setShowSearch(false);
          updateParams("search", "");
        }}
      />
    );
  },
);

Search.displayName = "Search";

export default Search;
